// make sure you update css when updating this media query
// app/stylesheets/site/_variables.scss
const xsScreen = window.matchMedia("(max-width: 479px)")
const smScreen = window.matchMedia("(max-width: 763px)")
const mdScreen = window.matchMedia("(max-width: 1023px)")
const mdLgOnlyScreen = window.matchMedia("(min-width : 764px)")

export default {
  // Reference: Modernizr touch detection
  isTouchScreen: () => (
    ("ontouchstart" in window) ||
    window.TouchEvent ||
    (window.DocumentTouch && document instanceof window.DocumentTouch) ||
    window.navigator.maxTouchPoints
  ),

  // return true if the screen width matches the size of a cellphone
  isXsScreen: () => xsScreen.matches,

  // return true if the screen width matches the size of a small tablet
  isSmScreen: () => smScreen.matches,

  // triggers this callback every time it enters or leaves the media query
  onSmScreen: (callback) => smScreen.addListener(callback),

  // return true if the screen width matches the size of a tablet or smaller
  isMdScreen: () => mdScreen.matches,

  // triggers this callback every time it enters or leaves the media query
  onMdScreen: (callback) => mdScreen.addListener(callback),

  // return true if the screen width matches the size of a tablet or desktop
  isMdLgOnlyScreen: () => mdLgOnlyScreen.matches
}
